import { AxiosError, AxiosResponse } from 'axios'
import { useQuery } from 'react-query'

import * as requests from './requests'
import { RvStatement, RvSummarySerialized } from './types'
import { ResponseError, ResponseSuccess } from '../../types'
import { BUSINESS_CODE } from '../auth'

export const KEY_GET_RV_STATEMENT_QUERY = 'useGetRVStatementQuery'

export const KEY_GET_RV_SUMMARY_QUERY = 'useGetRVSummaryQuery'

export const useGetRVStatementQuery = (enabled?: boolean) =>
  useQuery<AxiosResponse<ResponseSuccess<RvStatement>>, AxiosError<ResponseError>>(
    [KEY_GET_RV_STATEMENT_QUERY],
    () => requests.getRvStatement(),
    { enabled }
  )

export const useGetRVSummaryQuery = (businessCode?: BUSINESS_CODE, microRegionCode?: string) =>
  useQuery<AxiosResponse<ResponseSuccess<RvSummarySerialized>>, AxiosError<ResponseError>>(
    [KEY_GET_RV_SUMMARY_QUERY, businessCode, microRegionCode],
    () => requests.getRvSummary(businessCode!, microRegionCode),
    {
      enabled: !!businessCode,
      keepPreviousData: true
    }
  )
